import { t } from "../../../services/utils";
import React from "react";
import { primaryDark10, grey600 } from "../../../constants/colors";
import Icon from "@material-ui/core/Icon";
import Popover from "@material-ui/core/Popover";
import RadioButton from "@material-ui/core/Radio";
import Checkbox from "@material-ui/core/Checkbox";
import ThumbUpIcon from "@material-ui/icons/ThumbUp";
import ThumbDownIcon from "@material-ui/icons/ThumbDown";
import ThumbsUpDownIcon from "@material-ui/icons/ThumbsUpDown";
import { calculateTextHeight } from "../../../services/utils";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
import moment from "moment";
const truncate = require("html-truncate");
const MESSAGE_MAX_LENGTH = 200;
class CheckinDetailView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      expanded: true,
    };
  }
  showMore = (e) => {
    this.setState({
      anchorEl: e.currentTarget,
    });
  };
  handleClose = () => {
    this.setState({
      anchorEl: null,
    });
  };
  render = () => {
    let styles = {
      container: {
        height: "100%",
        backgroundColor: "white",
        display: "flex",
        paddingLeft: 16,
        paddingRight: 16,
        flexDirection: "column",
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
      },
      date: {
        color: "#2A234E",
        fontSize: 16,
        textAlign: "left",
        width: "50%",
        borderBottom: "1px solid #EAE9EF",
        display: "flex",
        alignItems: "center",
      },
      value: {
        fontSize: 16,
        color: "#2A234E",
        width: "50%",
        textAlign: "left",
        borderBottom: "1px solid #EAE9EF",
        display: "flex",
        alignItems: "center",
      },
      row: {
        display: "flex",
        width: "100%",
        height: 45,
      },
      heading: {
        fontSize: 13,
        color: "#524D70",
        width: "50%",
        borderBottom: "1px solid #EAE9EF",
        display: "flex",
        alignItems: "flex-end",
        paddingBottom: 5,
      },
      checkinValueBtn: {
        // marginBottom: 15,
        marginTop: 15,
        height: 55,
        width: 170,
        borderRadius: 3,
        backgroundColor: primaryDark10,
        boxShadow: "0 2px 2px 0 rgba(0,0,0,0.2)",
        // color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      },
      checkinValue: {
        display: "flex",
        alignItems: "Center",
      },
      showMore: {
        marginTop: 25,
        color: "#7B62E1",
      },
      header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      },
      icons: {
        marginRight: -15,
      },
      icon: {
        marginRight: 15,
        color: "#524D70",
        height: 24,
        width: 24,
        cursor: "pointer",
      },
      popupTitle: {
        fontWeight: "bold",
        color: "#2A234E",
      },
      footer: {
        backgroundColor: "#f6f6f6",
        borderTop: "1px solid #EAE9EF",
        marginLeft: -18,
        marginRight: -18,
        marginBottom: -18,
        marginTop: 15,
        paddingLeft: 3,
        height: 60,
        display: "flex",
        alignItems: "center",
      },
      radioButton: {
        width: "unset",
        marginBottom: 0,
        paddingLeft: 0,
        marginLeft: -3,
        paddingBottom: 5,
        paddingTop: 3,
      },
      checkinMessage: {},
      topBorder: {
        borderTop: "1px solid #EAE9EF",
      },
    };
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const { checkinData } = this.props;
    // console.log("checkin data", checkinData);

    let displayText = truncate(checkinData.m, MESSAGE_MAX_LENGTH);
    displayText = displayText.replace(/<[^/>][^>]*><\/[^>]+>/gim, "");
    return (
      <div style={styles.container}>
        {/* date is {checkinData.cd} */}
        <div
          style={styles.checkinMessage}
          className="checkin-message"
          dangerouslySetInnerHTML={{
            __html: displayText,
          }}
        />
        <div style={styles.checkinValueBtn}>
          {checkinData.dc && (
            <span style={styles.checkinValue}>
              <ThumbUpIcon
                style={{
                  color: "#1EA37B",
                  fontSize: 18,
                  marginRight: 5,
                }}
              />{" "}
              {t("yes")}
            </span>
          )}
          {checkinData.dc == false && (
            <span style={styles.checkinValue}>
              <ThumbDownIcon
                style={{
                  color: "#F44436",
                  fontSize: 18,
                  marginRight: 5,
                }}
              />{" "}
              {t("no")}
            </span>
          )}
          {checkinData.dc === null && (
            <span style={styles.checkinValue}>
              <ThumbsUpDownIcon
                style={{
                  color: "#05A9F4",
                  fontSize: 18,
                  marginRight: 5,
                }}
              />{" "}
              {t("didntCheckin")}
            </span>
          )}
        </div>
        {checkinData.rc.length > 0 && (
          <div
            style={{
              marginTop: 35,
            }}
          >
            {checkinData.rc.map((rc, index) => {
              return (
                <div
                  key={`checkin-${checkinData.ref}-${index}`}
                  style={styles.row}
                >
                  <div
                    style={{
                      ...styles.date,
                      ...(index === 0 && styles.topBorder),
                    }}
                  >
                    {moment(rc.cd).format("MMM D YYYY")}
                  </div>
                  <div
                    style={{
                      ...styles.value,
                      ...(index === 0 && styles.topBorder),
                    }}
                  >
                    {rc.dc && <span>{t("yes")}</span>}
                    {rc.dc == false && <span>{t("no")}</span>}
                    {rc.dc === null && <span>{t("didntCheckin")}</span>}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {/* <div style={styles.row}>
          <div style={styles.date}>Nov 13 2018, 3:30 PM</div>
          <div style={styles.value}>👍 yes</div>
         </div>
         <div style={styles.row}>
          <div style={styles.date}>Oct 20 2018, 3:30 PM</div>
          <div style={styles.value}>👎 no</div>
         </div>
         <div style={styles.row}>
          <div style={styles.date}>Oct 10 2018, 2:15 PM</div>
          <div style={styles.value}>👍 yes</div>
         </div> */}
        {/* <span style={styles.showMore} onClick={this.showMore}>
          Show More
         </span> */}
        <Popover
          id="simple-popper"
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            horizontal: "left",
            vertical: "top",
          }}
          transformOrigin={{
            horizontal: "left",
            vertical: "bottom",
          }}
          PaperProps={{
            style: {
              padding: 18,
              width: 440,
            },
          }}
        >
          <div style={styles.header}>
            <div style={styles.left}>
              <div style={styles.popupTitle}>{t("memorizeMyChoice")}</div>
            </div>
            <div style={styles.right}>
              <div style={styles.icons}>
                <img
                  src={ require( "../../../img/icon-close.png") }
                  style={styles.icon}
                  onClick={this.handleClose}
                />
              </div>
            </div>
          </div>
          <div
            style={{
              marginTop: 15,
            }}
          >
            <RadioButton
              checked={this.state.expanded}
              color="primary"
              style={styles.radioButton}
              onChange={() =>
                this.setState({
                  expanded: true,
                })
              }
            />
            {t("yesIWouldLikeToSeeAllPostsInExpandedForm")}
          </div>
          <div
            style={{
              marginTop: 10,
            }}
          >
            <RadioButton
              checked={!this.state.expanded}
              color="primary"
              style={styles.radioButton}
              onChange={() =>
                this.setState({
                  expanded: false,
                })
              }
            />
            {t("noKeepItShort")}
          </div>
          <div style={styles.footer}>
            <Checkbox
              color="primary"
              // checked={this.isChecked(member.id)}
              onChange={() => {}}
              style={styles.checkbox}
            />
            <span>
              {t("dontAskAgain")}{" "}
              <span
                style={{
                  color: "#524D70",
                }}
              >
                {t("youCanAlwaysChangeItInSettings")}
              </span>
            </span>
          </div>
        </Popover>
      </div>
    );
  };
  static getHeight(props) {
    const { checkinData } = props;
    let totalHeight = 0;
    let message = checkinData.m.replace(/<[^/>][^>]*><\/[^>]+>/gim, "");
    const messageHeight = calculateTextHeight(message, STORY_VIEW_WIDTH - 20, {
      fontSize: 16,
    });
    const btnHeight = 55 + 15 + 2; // adding btn margins and shadow
    let rowsHeight = 0;
    if (checkinData.rc.length > 0) {
      rowsHeight = 35 + checkinData.rc.length * 45;
    }
    totalHeight = messageHeight + btnHeight + rowsHeight + 20;
    return totalHeight;
  }
}
export default CheckinDetailView;
